import { useQuery } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";

interface Analytics {
  deviations: {
    mode: string;
    images: string[];
    floorplan_id: string;
  }[];
  visual_defects: {
    type: string;
    image: string;
    caption: string;
    bbox: {
      '2d': { x1: number; y1: number; x2: number; y2: number };
      '3d': {
        x_min: number; y_min: number; z_min: number;
        x_max: number; y_max: number; z_max: number;
      };
    };
  }[];
  progress: {
    [key: string]: {
      stage: string;
      pairs: {
        image1: string;
        image2: string;
        caption: string;
      }[];
      summary: {
        text: string;
        floorplan_id: string;
      }[];
      extensions: Record<string, unknown>;
    };
  };
  detections: {
    category: string;
    image: string;
    caption: string;
    bbox: {
      '2d': { x1: number; y1: number; x2: number; y2: number };
      '3d': {
        x_min: number; y_min: number; z_min: number;
        x_max: number; y_max: number; z_max: number;
      };
    };
  }[];
  extensions: Record<string, unknown>;
}

export const useGetScanAnalyticsQuery = (scanId: string) => {
  const { authApi } = useAuth();

  return useQuery({
    queryKey: ["scan-analytics", scanId],
    queryFn: async () => {
      if (!scanId) return null;
      const { data } = await authApi.get<Analytics>(`/scan/${scanId}/analytics`);
      return data;
    },
    enabled: !!scanId,
  });
};
